import numeral from 'numeral'

numeral.defaultFormat('$0,0.00')

const currencyFormat = (currency, format = '') => numeral(currency).format(format)

export default currencyFormat
